'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendCode = sendCode;
exports.sendVoiceCode = sendVoiceCode;
exports.resetVoiceCode = resetVoiceCode;
exports.confirmPassRecovery = confirmPassRecovery;
exports.resetStep = resetStep;
exports.resetError = resetError;
exports.sendPhoneToReducer = sendPhoneToReducer;
exports.showError = showError;

var _constants = require('../constants/');

function sendCode(phone, shopId) {
    return {
        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_FORM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.passRecoverySend(phone, shopId);
        }
    };
}

function sendVoiceCode(phone) {
    var source = 'restore_password';
    return {
        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.sendVoiceCode(phone, source);
        }
    };
}

function resetVoiceCode() {
    return {
        type: _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_RESET
    };
}

function confirmPassRecovery(login, password, code) {
    return {
        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userRestorePassword(login, password, code);
        }
    };
}

function resetStep() {
    return {
        type: _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_STEP
    };
}

function resetError() {
    return {
        type: _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_ERROR
    };
}

function sendPhoneToReducer(phone) {
    return {
        type: _constants.PassRecoveryConstants.PASS_RECOVERY_SET_PHONE,
        phone: phone
    };
}

function showError(error) {
    return {
        type: _constants.PassRecoveryConstants.PASS_RECOVERY_SHOW_ERROR,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/pass_recovery.js
// module id = 164
// module chunks = 0